var ConfigModel = /** @class */ (function () {
    function ConfigModel() {
        this.isDevelopment = process.env.NODE_ENV === "development";
        this.isTest = false;
    }
    Object.defineProperty(ConfigModel.prototype, "isTestOrDevelopment", {
        get: function () {
            return this.isDevelopment || this.isTest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigModel.prototype, "baseUrl", {
        get: function () {
            if (!this._baseUrl) {
                var baseTag = document.getElementsByTagName('base')[0];
                this._baseUrl = baseTag ? baseTag.getAttribute("href") || "" : "";
            }
            return this._baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    ConfigModel.prototype.initialise = function () {
    };
    return ConfigModel;
}());
export default ConfigModel;
